import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ILocationList } from "../../../Pages/Location/ILocation";

interface IUpdate extends IReduxState<ILocationList> {
  updateableDate?: ILocationList;
}

export const UpdateLocationSlicer = createSlice({
  name: "UpdateLocation",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateLocation: (state, _) => {
      state.isLoading = true;
    },
    successUpdateLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    LocationsUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateLocationState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateLocation,
  failureUpdateLocation,
  successUpdateLocation,
  LocationsUpdateableData,
  clearUpdateLocationState,
  clearUpdateableData,
} = UpdateLocationSlicer.actions;

export default UpdateLocationSlicer.reducer;
